var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href === '' ? 'button' : 'a',{tag:"compnent",staticClass:"oct-icon-button",class:[
    {
      'oct-icon-button--outlined': _vm.outline,
      'oct-icon-button--fixed': _vm.fix,
    },
    ("oct-icon-button--" + _vm.type),
    ("oct-icon-button--" + _vm.size)
  ],attrs:{"href":_vm.href === '' ? false : _vm.href}},[_c('oct-icon',{attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }